import { get } from "@/Api";
import { ViewInventory } from "@/Models/Views/ViewInventory";

namespace InventoryApi {
  const name = "Inventory";

  function getUrl(url: string) {
    return `${name}/${url}`;
  }
  export function getViews(): Promise<ViewInventory[]> {
    return get(getUrl("getViews"));
  }
}

export default InventoryApi;
